export enum SortButtons {
  Ascending = "sortAsc",
  Descending = "sortDesc",
  NewArray = "newArr",
}

export enum StackButtons {
  Push = "push",
  Pop = "pop",
  Reset = "reset"
}

export enum QueueButtons {
  Enqueue = "enqueue",
  Dequeue = "dequeue",
  Reset = "reset"
}

export enum ListButtons {
  AddTail = "addTail",
  AddHead = "addHead",
  DeleteHead = "deleteHead",
  DeleteTail = "deleteTail",
  AddByIndex = "addByIndex",
  DeleteByIndex = "deleteByIndex",
}
